<template>
  <div>
    <div class="spreadsheet-container" ref="spreadsheetContainer"></div>
    <button @click="addRows">{{ buttonLabel }}</button>
  </div>
</template>

<script>
import Handsontable from 'handsontable';
import 'handsontable/dist/handsontable.full.css';

export default {
  name: 'SpreadsheetComponent',
  props: {
    buttonLabel: {
      type: String,
      required: true
    },
    width: {
      type: String,
      default: '800px'
    },
    height: {
      type: String,
      default: '400px'
    }
  },
  data() {
    return {
      hotInstance: null
    };
  },
  mounted() {
    console.log('SpreadsheetComponent mounted');
    this.hotInstance = new Handsontable(this.$refs.spreadsheetContainer, {
      data: Array(100).fill().map(() => Array(26).fill('')), // Start with 100 empty rows
      rowHeaders: true,
      colHeaders: true,
      contextMenu: true,
      manualRowResize: true,
      manualColumnResize: true,
      minRows: 100,
      minCols: 26,
      colWidths: 100, // Set a default column width
      width: this.width,
      height: this.height,
      licenseKey: 'non-commercial-and-evaluation' // for non-commercial use only
    });
   // console.log('Handsontable instance created:', this.hotInstance);

    this.$refs.spreadsheetContainer.addEventListener('paste', this.onPaste);
  },
  beforeUnmount() {
  //  console.log('SpreadsheetComponent beforeUnmount');
    if (this.hotInstance) {
      this.hotInstance.destroy();
    }
  },
  methods: {

    onPaste(event) {
  event.preventDefault(); // Prevent Handsontable's default paste

  const clipboardData = event.clipboardData || window.clipboardData;
  const pastedData = clipboardData.getData('Text');

  this.insertParsedPastedData(pastedData);
},

insertParsedPastedData(pastedData) {
  const trimmedData = pastedData.trim();
  const rows = this.customSplit(trimmedData);

  const parsedData = rows.map(row =>
    row.split('\t').map(cell => cell.trim())
  );

  const selection = this.hotInstance.getSelected();
  if (!selection || selection.length === 0) {
    alert("Please select a starting cell before pasting.");
    return;
  }

  const [startRow, startCol] = selection[0];

  // Use populateFromArray for fast batch paste
  this.hotInstance.populateFromArray(
    startRow, startCol,
    parsedData,
    undefined, undefined,
    'paste' // source
  );
}
,
  customSplit(input) {
    let rows = [];
    let currentRow = '';
    let inQuotes = false;

    for (let i = 0; i < input.length; i++) {
      const currentChar = input[i];
      const nextChar = i < input.length - 1 ? input[i + 1] : '';

      currentRow += currentChar;

      if (currentChar === '"' && nextChar !== '"') { // Toggle the inQuotes state, ignore double quotes ""
        inQuotes = !inQuotes;
      } else if (currentChar === '\n' && !inQuotes) { // End of row
        rows.push(currentRow.trim());
        currentRow = '';
      }
    }

    if (currentRow.length > 0) {
      rows.push(currentRow.trim()); // Add the last row
    }

    return rows.filter(row => row !== ''); // Filter out any empty rows
  }
,
    addRows() {
      const currentData = this.hotInstance.getData();
      const newData = currentData.concat(Array(100).fill().map(() => Array(26).fill('')));
      this.hotInstance.loadData(newData);
    },
    getData() {
      return this.hotInstance.getData();
    },
    loadData(data) {
      this.hotInstance.loadData(data);
    }
  }
};
</script>

<style>
.spreadsheet-container {
  margin: 20px;
  border: 1px solid #ccc; /* Add border to see the container */
  overflow: hidden; /* Ensure overflow is handled */
}
button {
  display: block;
  margin: 20px auto;
  padding: 10px 20px;
  font-size: 16px;
}
</style>
